<template>
  <div>
    <div class="row">
      <div class="col-12">
        <b-card header="Working Week and Hours" header-tag="h4" body-class="mb-3 pb-2 record_card_body">
          <div class="row">
            <!-- Working Week -->
            <div class="col-xl-8 form-group">
              <label class="form-label" for="working_week">Working Week</label>
              <p id="working_week">
                <span v-for="(day, i) in working_week_no_bank_hols">{{ day.replace(/work_/g, "") | capitalWords }}
                  <span v-if="i < working_week_no_bank_hols.length - 1">, </span>
                </span>
              </p>
            </div>
            <div class="col-xl-4">
              <label class="form-label" for="work_bank_holidays">Work Bank Holidays</label>
              <p id="work_bank_holidays">
                <span v-if="working_week.includes('work_bank_holidays')">Yes</span>
                <span v-if="!working_week.includes('work_bank_holidays')">No</span>
              </p>
            </div>

            <div class="col-12">
              <hr class="mt-0 mb-3">
            </div>
            <!-- Start Time -->
            <div class="col-xl-3 form-group">
              <label class="form-label" for="start_time">Start Time</label>
              <p id="start_time">{{ order_job.rel_order_position_shift.start_time }}</p>
            </div>
            <!-- End Time -->
            <div class="col-xl-3 form-group">
              <label class="form-label" for="end_time">End Time</label>
              <p id="end_time">{{ order_job.rel_order_position_shift.end_time }}</p>
            </div>
            <!-- Lunch Length -->
            <div class="col-xl-3 form-group">
              <label class="form-label" for="lunch_break_length">Lunch Length</label>
              <p id="lunch_break_length">{{ order_job.rel_order_position_shift.lunch_break_length }}</p>
            </div>
            <!-- Lunch Paid -->
            <div class="col-xl-3 form-group">
              <label class="form-label" for="lunch_break_paid">Lunch Paid</label>
              <p id="lunch_break_paid">
                <span v-if="order_job.rel_order_position_shift.lunch_break_paid">Yes</span>
                <span v-if="!order_job.rel_order_position_shift.lunch_break_paid">No</span>
              </p>
            </div>
            <div class="col-12">
              <hr class="mt-0 mb-3">
            </div>
            <!-- Total Hours per Shift -->
            <div class="col-xl-6 form-group">
              <label class="form-label" for="total_hours_per_shift">Total Hours per Shift</label>
              <p id="total_hours_per_shift">{{ order_job.rel_order_position_shift.total_hours_per_week }}</p>
            </div>
            <!-- Total Hours -->
            <div class="col-xl-6 form-group">
              <label class="form-label" for="total_hours_per_week">Total Hours per Week</label>
              <p id="total_hours_per_week">{{ calc_total_max_hours(order_job.rel_order_position_shift.total_hours_per_week, working_week) }}</p>
            </div>
          </div>
        </b-card>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-card header="Rates for Position" header-tag="h4" body-class="mb-3 pb-2 record_card_body">
          <div class="row">
            <div class="col-12" v-if="crmType === 'recruitment'">
              <div class="row">
                <div class="col-12">
                  <h5 class="text-uppercase">Recruitment Margin : &nbsp;&nbsp; {{ order_job.rel_order_position.recruitment_margin_perc | percentage }}</h5>
                  <hr>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div v-for="(r, i) in order_job.rel_order_position_rates">
                <h5>Rate {{ i + 1 }}</h5>

                <div class="row">
                  <!-- RATE TYPE -->
                  <div class="col-lg-3 form-group">
                    <label class="form-label" :for="'rate_type_' + i">Rate Type</label>
                    <p :id="'rate_type_' + i">{{ r.rate_type }}</p>
                  </div>
                  <!-- PAY TYPE -->
                  <div class="col-lg-3 form-group">
                    <label class="form-label" :for="'pay_type_' + i">Pay Type</label>
                    <p :id="'pay_type_' + i">{{ r.pay_type }}</p>
                  </div>
                  <!-- PAY AMOUNT -->
                  <div class="col-lg-3 form-group">
                    <label class="form-label" :for="'pay_amount_' + i">Pay Amount</label>
                    <p :id="'pay_amount_' + i">{{ r.pay_amount | currency }}</p>
                  </div>
                  <!-- ADMIN FEE -->
                  <div class="col-lg-3 form-group">
                    <label class="form-label" :for="'admin_fee_amount_' + i"><span v-if="crmType === 'payroll'">Admin Fee</span>
                      <span v-if="crmType === 'recruitment'">Charge Rate</span></label>
                    <p :id="'admin_fee_amount_' + i">
                      <span v-if="r.admin_fee_type === '£ (Pound)'">{{ r.admin_fee_amount | currency }}</span>
                      <span v-else-if="r.admin_fee_type === '% (Percentage)'">{{ r.admin_fee_amount | percentage }}</span>
                    </p>
                  </div>
                  <!-- RETENTION PERCENTAGE (if contracts) -->
                  <div class="col-lg-3 offset-lg-9 form-group" v-if="order_job.order.order_type === 'Contract'">
                    <label class="form-label" :for="'retention_percentage_' + i">Retention Percentage</label>
                    <p :id="'retention_percentage_' + i">{{ r.retention_percentage | percentage }}</p>
                  </div>

                  <div class="col-12" v-if="i < Object.keys(order_job.rel_order_position_rates).length - 1">
                    <hr class="mt-1">
                  </div>
                </div>

              </div>
            </div>
          </div>
        </b-card>
      </div>
    </div>
    <div class="row" v-if="crmType === 'recruitment' && order_job.order.order_type === 'Permanent'">
      <div class="col-12">
        <b-card header="Permanent Package Information" header-tag="h4" body-class="mb-3 pb-2 record_card_body">
          <div class="row">
            <!-- Pension -->
            <div class="col-12">
              <h5>Pension</h5>
              <div class="row">
                <div class="col-xl-6 form-group">
                  <label class="form-label" for="pension_percentage">Pension Percentage</label>
                  <p id="pension_percentage">{{ order_job.rel_order_position_perm.pension_percentage }}</p>
                </div>
                <div class="col-xl-6 form-group">
                  <label class="form-label" for="pension_in_charge">Percentage included in charge</label>
                  <p id="pension_in_charge">
                    <span v-if="order_job.rel_order_position_perm.pension_included_in_charge">Yes</span>
                    <span v-else>No</span>
                  </p>
                </div>
              </div>
            </div>
            <!-- Bonus -->
            <div class="col-12" v-if="order_job.rel_order_position_perm.bonus">
              <h5>Bonus</h5>
              <div class="row">
                <div class="col-xl-6 form-group">
                  <label class="form-label" for="bonus_how_calculated">How bonus calculated</label>
                  <pre v-if="order_job.rel_order_position_perm.bonus_how_calculated !== null" style="padding-top: 12px;" id="bonus_how_calculated">{{ order_job.rel_order_position_perm.bonus_how_calculated.trim() }}</pre>
                  <p v-else>-</p>
                </div>
                <div class="col-xl-6 form-group">
                  <label class="form-label" for="bonus_when_paid">When bonus paid</label>
                  <pre v-if="order_job.rel_order_position_perm.bonus_when_paid !== null" style="padding-top: 12px;" id="bonus_when_paid">{{ order_job.rel_order_position_perm.bonus_when_paid.trim() }}</pre>
                  <p v-else>-</p>
                </div>
                <div class="col-xl-6 form-group">
                  <label class="form-label" for="bonus_amount_per_annum">Bonus amount per annum</label>
                  <p id="bonus_amount_per_annum">{{ order_job.rel_order_position_perm.bonus_amount_per_annum | currency }}</p>
                </div>
                <div class="col-xl-6 form-group">
                  <label class="form-label" for="bonus_included_in_charge">Bonus included in charge</label>
                  <p id="bonus_included_in_charge">
                    <span v-if="order_job.rel_order_position_perm.bonus_included_in_charge">Yes</span>
                    <span v-else>No</span>
                  </p>
                </div>
              </div>
            </div>
            <!-- Car Allowance -->
            <div class="col-12" v-if="order_job.rel_order_position_perm.car_allowance">
              <h5>Car allowance</h5>
              <div class="row">
                <div class="col-xl-4 form-group">
                  <label class="form-label" for="car_allowance_make_model">Car make/model</label>
                  <p id="car_allowance_make_model">{{ order_job.rel_order_position_perm.car_allowance_make_model }}</p>
                </div>
                <div class="col-xl-4 form-group">
                  <label class="form-label" for="car_allowance_amount_per_annum">Car allowance per annum</label>
                  <p id="car_allowance_amount_per_annum">{{ order_job.rel_order_position_perm.car_allowance_amount_per_annum | currency }}</p>
                </div>
                <div class="col-xl-4 form-group">
                  <label class="form-label" for="car_allowance_included_in_charge">Car allowance included in charge</label>
                  <p id="car_allowance_included_in_charge">
                    <span v-if="order_job.rel_order_position_perm.car_allowance_included_in_charge">Yes</span>
                    <span v-else>No</span>
                  </p>
                </div>
              </div>
            </div>
            <!-- Health care -->
            <div class="col-12" v-if="order_job.rel_order_position_perm.health_care">
              <h5>Health Care</h5>
              <div class="row">
                <div class="col-xl-4 form-group">
                  <label class="form-label" for="health_care_type">Health care type</label>
                  <p id="health_care_type">{{ order_job.rel_order_position_perm.health_care_type }}</p>
                </div>
                <div class="col-xl-4 form-group">
                  <label class="form-label" for="health_care_amount_per_annum">Health care amount per annum</label>
                  <p id="health_care_amount_per_annum">{{ order_job.rel_order_position_perm.health_care_amount_per_annum | currency }}</p>
                </div>
                <div class="col-xl-4 form-group">
                  <label class="form-label" for="health_care_included_in_charge">Health care included in charge</label>
                  <p id="health_care_included_in_charge">
                    <span v-if="order_job.rel_order_position_perm.health_care_included_in_charge">Yes</span>
                    <span v-else>No</span>
                  </p>
                </div>
              </div>
            </div>
            <!-- Other Benefits -->
            <div class="col-12" v-if="order_job.rel_order_position_perm.any_other_benefits">
              <h5>Other Benefits</h5>
              <div class="row">
                <div class="col-12 form-group">
                  <label class="form-label" for="any_other_benefits_description">Other Benefits Description</label>
                  <pre v-if="order_job.rel_order_position_perm.any_other_benefits_description !== null" style="padding-top: 12px;" id="any_other_benefits_description">{{ order_job.rel_order_position_perm.any_other_benefits_description.trim() }}</pre>
                  <p v-else>-</p>
                </div>
                <div class="col-xl-6 form-group">
                  <label class="form-label" for="any_other_benefits_amount_per_annum">Other benefits amount per annum</label>
                  <p id="any_other_benefits_amount_per_annum">{{ order_job.rel_order_position_perm.any_other_benefits_amount_per_annum | currency }}</p>
                </div>
                <div class="col-xl-6 form-group">
                  <label class="form-label" for="any_other_benefits_included_in_charge">Other benefits included in charge</label>
                  <p id="any_other_benefits_included_in_charge">
                    <span v-if="order_job.rel_order_position_perm.any_other_benefits_included_in_charge">Yes</span>
                    <span v-else>No</span>
                  </p>
                </div>
              </div>
            </div>
            <div class="col-12">
              <hr>
            </div>
            <!-- Salary -->
            <div class="col-12">
              <h5>Salary Range</h5>
              <div class="row">
                <div class="col-xl-6 form-group">
                  <label class="form-label" for="salary_range_start">Salary range start</label>
                  <p id="salary_range_start">{{ order_job.rel_order_position_perm.salary_range_start | currency }}</p>
                </div>
                <div class="col-xl-6 form-group">
                  <label class="form-label" for="salary_range_end">Salary range end</label>
                  <p id="salary_range_end">{{ order_job.rel_order_position_perm.salary_range_end | currency }}</p>
                </div>
              </div>
            </div>
          </div>
        </b-card>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-card header="Position Details" header-tag="h4" body-class="mb-3 pb-2 record_card_body">
          <div class="row">
            <!-- Industry -->
            <div class="col-xl-6 form-group">
              <label class="form-label" for="short_site_name">Sector</label>
              <p id="short_site_name">{{ order_job.rel_order_position.sector }}</p>
            </div>
            <!-- Job Title -->
            <div class="col-xl-6 form-group">
              <label class="form-label" for="job_title">Job Title</label>
              <p id="job_title">{{ order_job.rel_order_position.job_title }}</p>
            </div>
            <!-- Essential Qualifications -->
            <div class="col-12 form-group">
              <label class="form-label" for="essential_qualifications">Essential Qualifications</label>
              <div v-if="essential_qualifications !== null" id="essential_qualifications">
                <p>
                  <span v-for="(eq, i) in essential_qualifications">{{ eq.name }}
                    <span v-if="i < Object.keys(essential_qualifications).length - 1">, </span>
                  </span>
                </p>
              </div>
              <div v-else><p>-</p></div>
            </div>
            <!-- Key Responsibilities -->
            <div class="col-12 form-group">
              <label class="form-label" for="key_responsibilities">Key Responsibilities</label>
              <pre v-if="order_job.rel_order_position.key_responsibilities !== null" style="padding-top: 12px;" id="key_responsibilities">{{ order_job.rel_order_position.key_responsibilities.trim() }}</pre>
              <p v-else>-</p>
            </div>
            <!-- Key Skills / Experience -->
            <div class="col-12 form-group">
              <label class="form-label" for="key_skills_experience">Key Skills / Experience</label>
              <pre v-if="order_job.rel_order_position.key_skills_experience !== null" style="padding-top: 12px;" id="key_skills_experience">{{ order_job.rel_order_position.key_skills_experience.trim() }}</pre>
              <p v-else>-</p>
            </div>
            <!-- Job Brief -->
            <div class="col-12 form-group">
              <label class="form-label" for="job_brief">Job Brief</label>
              <pre v-if="order_job.rel_order_position.job_brief !== null" style="padding-top: 12px;" id="job_brief">{{ order_job.rel_order_position.job_brief.trim() }}</pre>
              <p v-else>-</p>
            </div>
            <!-- Known Health & Safety Risks -->
            <div v-if="order_job.order.order_type === 'Contract'" class="col-12 form-group">
              <label class="form-label" for="health_safety_risks">Known Health & Safety Risks</label>
              <pre v-if="order_job.rel_order_position.health_safety_risks !== null" style="padding-top: 12px;" id="health_safety_risks">{{ order_job.rel_order_position.health_safety_risks.trim() }}</pre>
              <p v-else>-</p>
            </div>
            <!-- PPE / Tools Required -->
            <div v-if="order_job.order.order_type === 'Contract'" class="col-12 form-group">
              <label class="form-label" for="ppe_tools_required">PPE / Tools Required</label>
              <pre v-if="order_job.rel_order_position.ppe_tools_required !== null" style="padding-top: 12px;" id="ppe_tools_required">{{ order_job.rel_order_position.ppe_tools_required.trim() }}</pre>
              <p v-else>-</p>
            </div>
            <!-- Additional Assignment Details -->
            <div class="col-12 form-group">
              <label class="form-label" for="key_skills_experience">Additional Assignment Details</label>
              <pre v-if="order_job.rel_order_position.additional_assignment_details !== null" style="padding-top: 12px;" id="additional_assignment_details">{{ order_job.rel_order_position.additional_assignment_details.trim() }}</pre>
              <p v-else>-</p>
            </div>
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "position_details",
  props: ['order_job'],
  data() {
    return {
      essential_qualifications: JSON.parse(this.order_job.rel_order_position.essential_qualifications),
      working_week: [],
    }
  },
  computed: {
    working_week_no_bank_hols() {
      return this.working_week.filter(function (val) { return val !== 'work_bank_holiday' });
    }
  },
  beforeMount() {
    if (this.order_job.rel_order_position_shift.work_monday) {
      this.working_week.push('work_monday')
    }
    if (this.order_job.rel_order_position_shift.work_tuesday) {
      this.working_week.push('work_tuesday')
    }
    if (this.order_job.rel_order_position_shift.work_wednesday) {
      this.working_week.push('work_wednesday')
    }
    if (this.order_job.rel_order_position_shift.work_thursday) {
      this.working_week.push('work_thursday')
    }
    if (this.order_job.rel_order_position_shift.work_friday) {
      this.working_week.push('work_friday')
    }
    if (this.order_job.rel_order_position_shift.work_saturday) {
      this.working_week.push('work_saturday')
    }
    if (this.order_job.rel_order_position_shift.work_sunday) {
      this.working_week.push('work_sunday')
    }
    if (this.order_job.rel_order_position_shift.work_bank_holidays) {
      this.working_week.push('work_bank_holidays')
    }
  },
  methods: {
    calc_total_max_hours(total_hours, week) {
      let week_without_bank_hol = week.filter(function (val) { return val !== 'work_bank_holiday' });
      return parseFloat(total_hours) * parseInt(week_without_bank_hol.length);
    },
  }
}
</script>

<style scoped lang="scss">
pre {
  font-family:   $font-family-header;
  margin-bottom: 0;
  margin-top:    0;
  font-size:     0.8rem;
}
</style>
